import React, { useState, useEffect } from "react";
// External
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import { useLocation } from "react-router-dom";
// Icons
import FilterListIcon from "@mui/icons-material/FilterList";
// Internal
import ClickAwayListener from "@mui/material/ClickAwayListener";
import ScrollItem from "./Item";
import useStyles from "./useStyles";
export default (function (_a) {
    var filterList = _a.filterList, openFullFilters = _a.openFullFilters;
    // The Quick filters use a single Popper whose contents change based on the tab you click on
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = useState(null), innerPopper = _c[0], setInnerPopper = _c[1];
    var _d = useState(false), openPopper = _d[0], setOpenPopper = _d[1];
    var _e = useState(null), arrowRef = _e[0], setArrowRef = _e[1];
    var _f = useState(false), open = _f[0], setOpen = _f[1];
    var handleClick = function (index) {
        return function (_a) {
            var currentTarget = _a.currentTarget;
            setAnchorEl(currentTarget);
            setInnerPopper(index);
            setOpenPopper(innerPopper === index ? !openPopper : true);
            setOpen(innerPopper === index ? function (prev) { return !prev; } : true);
        };
    };
    var closePopper = function () {
        setOpenPopper(false);
        setInnerPopper(null);
        setAnchorEl(null);
    };
    var onListClick = function () {
        closePopper();
        openFullFilters();
    };
    var handleClickAway = function (event) {
        if (event.target instanceof HTMLElement &&
            // Check if the dataset id is not tab then close popper.
            // If the id is tab it means that we are clicking adajacent tabs which we want to remain open
            event.target.dataset.id !== "tab" &&
            // Check if the click xth position is zero, which means we are not clicking the left and right arrows
            // of Date Time Picker (we want the popper to remain open if xth position is not zero)
            event.target.getBoundingClientRect().x === 0) {
            closePopper();
            setOpen(false);
        }
    };
    var location = useLocation();
    useEffect(function () { return closePopper(); }, [location.search]);
    var classes = useStyles();
    return (React.createElement(Box, { marginRight: 1 },
        React.createElement(Tabs, { indicatorColor: "primary", scrollButtons: false, textColor: "primary", value: false, variant: "scrollable" },
            React.createElement(ScrollItem, { icon: React.createElement(FilterListIcon, { fontSize: "small" }), title: "Change Search Criteria", onClick: onListClick }),
            filterList.map(function (_a, index) {
                var label = _a.label;
                return (React.createElement(ScrollItem, { label: label, onClick: handleClick(index), key: "siKey".concat(label) }));
            })),
        open ? (React.createElement(ClickAwayListener, { onClickAway: handleClickAway, touchEvent: false },
            React.createElement(Popper, { anchorEl: anchorEl, className: classes.popper, open: openPopper, placement: "bottom-start", modifiers: [
                    {
                        name: "arrow",
                        enabled: true,
                        options: {
                            element: arrowRef,
                        },
                    },
                ] },
                React.createElement("div", { className: classes.arrow, ref: setArrowRef }),
                React.createElement(Paper, { elevation: 3, className: classes.paper },
                    React.createElement(Box, { width: 200 }, innerPopper !== null && filterList[innerPopper].component))))) : null));
});
//# sourceMappingURL=index.js.map